module.exports = __webpack_public_path__ + "img/photo16.f6570e3c.jpg";